module.exports = __webpack_public_path__ + "static/media/01-06.c9183462.mp3";